// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'

const FoundationModal = ({ modalId, classes, children }) => {
  const modal = () => $(`#${modalId}`)

  const close = () => {
    modal().foundation('close')
  }

  const combinedClasses = () => (['reveal', classes].join(' '))

  return (
    <div className={combinedClasses()} id={modalId} data-reveal>
      <button className='close-button' aria-label='Close modal' type='button' onClick={close}>
        <span aria-hidden='true'>&times;</span>
      </button>
      {children}
    </div>
  )
}

FoundationModal.propTypes = {
  modalId: PropTypes.string.isRequired,
  classes: PropTypes.string,
  children: PropTypes.node.isRequired
}

export default FoundationModal
